import { BaseFCProps, FC, Modal, ModalMap } from "../components";

export const VenueModal: FC = ({ selector = '[data-venue-modal]' }: BaseFCProps = {}) => {
  Array.from(document.querySelectorAll(selector)).forEach((node) => {
    const modalNode = node as HTMLElement;
    const modal = Modal.create({
      action: 'click',
      target: modalNode.dataset.venueModal || '',
      trigger: node as HTMLElement,
      backdrop: true
    });
    try {
      const content = modal.getModalElement().dataset.venueMap || '{}';
      const id = modal.getModalElement().dataset.venueId;
      if (!id) {
        throw new Error('ERROR_VENUE_ID_NOT_FOUND');
      }
      const options = JSON.parse(content.replace(/'/g, ''));
      const map = ModalMap.create(
        options,
        id,
      );
      modal.getModalElement().addEventListener('shown.bs.modal', () => {
        map.invalidateSize();
      });
      map.render();
    } catch (e) {
      console.error(e);
      throw new Error('ERROR_PARSING_MAP_OPTIONS')
    }
    
    modal.render();
  });
}